export const SEARCH_LISTING_UXFB_EVENT_NAME = 'search_listing';
export const SERP_FILTER_APPLIED_UXFB_EVENT_NAME = 'serp_filter_applied';
export const UXFB_CLIENT_EVENTS_ENABLED_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
